import { render } from "./Purchase_Vendor_Dialog.vue?vue&type=template&id=17ade53a&scoped=true&ts=true"
import script from "./Purchase_Vendor_Dialog.vue?vue&type=script&lang=ts"
export * from "./Purchase_Vendor_Dialog.vue?vue&type=script&lang=ts"

import "./Purchase_Vendor_Dialog.vue?vue&type=style&index=0&id=17ade53a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ade53a"]])

export default __exports__